import axios from "axios";

const state = {
  userName: "",
  userId: "",
  teamIds: [],
  accessToken: "",
  refreshToken: "",
  userAuthority: ""
};

const getters = {
  getUserInfo(state) {
    return state;
  }
};

const mutations = {
  SET_USER_INFO(state, param) {
    state.userName = param.userName;
    state.userId = param.userId;
    state.teamIds = param.teamIds;
    state.accessToken = param.accessToken;
    state.refreshToken = param.refreshToken;
    state.userAuthority = param.userAuthority;
  }
};

const actions = {
  login({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/login", data)
        .then(response => {
          console.log("response", response);
          const userParam = {
            userName: response.data.user.name,
            userId: response.data.user.id,
            teamIds: response.data.user.team_ids,
            accessToken: response.data.user.access_token,
            refreshToken: response.data.user.refresh_token,
            userAuthority: response.data.user.user_authority
          };
          commit("SET_USER_INFO", userParam);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  refresh({ commit }) {
    return new Promise((resolve, reject) => {
      console.log("リフレッシュしようとはしてる");
      axios
        .post("/api/refresh-token", { refresh_token: state.refresh_token })
        .then(response => {
          const userParam = {
            accessToken: response.data.user.access_token,
            refreshToken: response.data.user.refresh_token
          };
          console.log("param", userParam);
          commit("SET_USER_INFO", userParam);
          resolve();
        })
        .catch(error => {
          console.log(error.response.data);
          reject(error.response.data);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
